import { SchemaTimestamp, ZodArrayToEnum } from '@axiom/types';
import { z } from 'zod';

import { TopTaskCategorySchema } from './top-task-category';

export const TopTaskTypes = {
  TIME_TO_SUBMISSION: 'TIME_TO_SUBMISSION',
  CHECK_IN: 'CHECK_IN',
  IDLE_REMINDER: 'IDLE_REMINDER',
  CANDIDATE_ISSUE_MISSING_FOCUS_AREA: 'CANDIDATE_ISSUE_MISSING_FOCUS_AREA',
  CANDIDATE_ISSUE_MISSING_BUSINESS_TITLE:
    'CANDIDATE_ISSUE_MISSING_BUSINESS_TITLE',
  CANDIDATE_ISSUE_MISSING_ADDRESS_FIELDS:
    'CANDIDATE_ISSUE_MISSING_ADDRESS_FIELDS',
  CANDIDATE_ISSUE_MISSING_PRACTICE_START_YEAR:
    'CANDIDATE_ISSUE_MISSING_PRACTICE_START_YEAR',
  COOL_CANDIDATES_ON_CLOSED_OPPORTUNITY:
    'COOL_CANDIDATES_ON_CLOSED_OPPORTUNITY',
  EXPERIENCE_DESCRIPTION_LENGTH_EXCEPTION:
    'EXPERIENCE_DESCRIPTION_LENGTH_EXCEPTION',
  CANDIDATE_REPUTATION_FEEDBACK: 'CANDIDATE_REPUTATION_FEEDBACK',
  CANDIDATE_REPUTATION_COACHING_ALERT: 'CANDIDATE_REPUTATION_COACHING_ALERT',
  CANDIDATE_REPUTATION_EXPECTATIONS_NOT_MET:
    'CANDIDATE_REPUTATION_EXPECTATIONS_NOT_MET',
  SEND_KICKOFF: 'SEND_KICKOFF',
} as const;

export const TopTaskTopTaskTypes = Object.values(TopTaskTypes);

export const TopTaskSchema = z.object({
  candidateCalculatedDisplayName: z.string().max(255).nullable(),
  candidateId: z.string().uuid().nullable(),
  createdAt: SchemaTimestamp,
  id: z.string().uuid(),
  opportunityId: z.string().uuid(),
  opportunityJobName: z.string().max(255).nullable(),
  ownerId: z.string().uuid(),
  reputationDetailsId: z.string().uuid().nullable(),
  snoozedAt: SchemaTimestamp.nullable(),
  taskExpectedCompletionDateTime: SchemaTimestamp,
  taskExpectedStartDateTime: SchemaTimestamp,
  topTaskCategory: TopTaskCategorySchema,
  topTaskType: z.enum(ZodArrayToEnum(TopTaskTopTaskTypes)),
});

export type TopTask = z.infer<typeof TopTaskSchema>;
